import ugcRequest from "@util/net/ugc";
import request from "@util/net/request";
import { AxiosRequestConfig } from "axios";
import API from "./apiConfig";

export const getVisualSearch = (params: FormData) =>
  ugcRequest.post(API.VISUAL_SEARCH, params);
export const getProduct = (config: AxiosRequestConfig) =>
  request.get(API.PRODUCT, config);
export const getOutfit = (config: AxiosRequestConfig) =>
  request.get(API.OUTFIT, config);
export const getFavoriteStatus = (config: AxiosRequestConfig) =>
  request.get(API.FAVORITE_SEARCH, config);
export const addFavorites = (params: any[]) =>
  request.post(API.FAVORITE, params);
export const delFavorites = (config: any) =>
  request.del(API.FAVORITE, { params: { id: config } });
export const getOutfitFavoriteStatus = (config: AxiosRequestConfig) =>
  request.get(API.OUTFIT_FAVORITE_SEARCH, config);
export const addOutfitFavorites = (params: any[], config: AxiosRequestConfig) =>
  request.post(API.OUTFIT_FAVORITE, params, config);
export const delOutfitFavorites = (
  styleId: string,
  config: AxiosRequestConfig
) => request.del(`${API.OUTFIT_FAVORITE}/${styleId}`, config);
//newPost and newGet use in call zero result page ugc api. Feedback and emptyResult api
export const postVisualSearchFeedback = (params: FormData) =>
  ugcRequest.newPost(API.VISUAL_SEARCH_FEEDBACK, params);
export const postVisualSearchEmptyResult = (params: FormData) =>
  ugcRequest.newPost(API.VISUAL_SEARCH_EMPTY_RESULT, params);
export const getProductSkus = (params: any, config: any) =>
  request.getFavoritePopup(API.PRODUCT_SKUS, params, config);
export const getProductL2SkusWithImage = (params: any, config: any) =>
  request.getFavoritePopupForGuApp(API.PRODUCT_SKUS_WITH_IMAGE, params, config);
